import React from "react";
// aos improts
import AOS from "aos";
import "./../../node_modules/aos/dist/aos.css";

const Welcome = ({ setWelcome }) => {
  AOS.init({
    duration: 1000,
  });
  return (
    <div className="overflow-hidden w-full">
      <div
        className="h-screen  bg-gray-100  relative "
        style={{
          backgroundImage: `url(${"https://1.bp.blogspot.com/-31rRofTF9ps/YP7xTHtTZ7I/AAAAAAAABVw/IFJ_kDcmgG4Aa6qzyEw3NZp5HNX22Ep8wCLcBGAsYHQ/s16000/landing.jpg"})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <div className="h-1/4 pt-4 pl-4">
          <img src="logo.png" alt="" className=" h-10 " />
        </div>

        <div className="text-white text-5xl   pl-4 ">
          <div
            style={{ textShadow: "0 0 10px rgba(0,0,0,1)" }}
            data-aos="zoom-out"
          >
            WE ARE CONSTANTLY
          </div>
          <div
            style={{ textShadow: "0 0 10px rgba(0,0,0,1)" }}
            data-aos="zoom-in"
          >
            EVOLVING & ADAPTING.
          </div>
        </div>
        <div className="flex justify-content-center absolute bottom-20  w-full cursor-pointer">
          <div
            onClick={() => {
              setWelcome(false);
            }}
            className="flex  border-2 p-2 border-red-700  bg-red-700 text-white "
          >
            Enter the website
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 ml-2 "
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
